import React from "react";
import Icon1 from "../../img/brands/brand-1.png";
import Icon2 from "../../img/brands/brand-2.png";
import Icon3 from "../../img/brands/brand-3.png";
import Icon4 from "../../img/brands/brand-4.png";
import Icon5 from "../../img/brands/brand-5.png";
import Icon6 from "../../img/brands/brand-6.png";
import Icon7 from "../../img/brands/brand-7.png";
import Icon8 from "../../img/brands/brand-8.png";
import Icon9 from "../../img/brands/brand-9.png";
import Icon10 from "../../img/brands/brand-10.png";
import Icon11 from "../../img/brands/brand-11.png";
import Icon12 from "../../img/brands/brand-12.png";
import Icon13 from "../../img/brands/brand-13.png";
import Icon14 from "../../img/brands/brand-14.png";
import Icon15 from "../../img/brands/brand-15.png";
import Icon16 from "../../img/brands/brand-16.png";
import Icon17 from "../../img/brands/brand-17.png";
import Icon18 from "../../img/brands/brand-18.png";
import Icon19 from "../../img/brands/brand-19.png";
import Icon20 from "../../img/brands/brand-20.png";
import Icon21 from "../../img/brands/brand-21.png";
import Icon22 from "../../img/brands/brand-22.png";
import Icon23 from "../../img/brands/brand-23.png";


import {
  BrandContainer,
  BrandWrapper,
  BrandRec,
  BrandTextWrapper,
  BrandP,
  BrandH1,
  BrandIconsContainer,
  BrandIcon,
  BrandIconsContainerMobile,
} from "./BrandElements";

const BrandSection = () => {
    return (
        <>
        <BrandContainer id="brands">
          <BrandWrapper>
            <BrandIconsContainer>
                <BrandIcon src={Icon1} width='130'/>
                <BrandIcon src={Icon2} width='170'/>
                <BrandIcon src={Icon3} width='130'/>
                <BrandIcon src={Icon4} width='140'/>
                <BrandIcon src={Icon5} width='130'/>
                <BrandIcon src={Icon6} width='100'/>
                <BrandIcon src={Icon7} width='70'/>
            </BrandIconsContainer>
            <BrandIconsContainer>
                <BrandIcon src={Icon8} width='100'/>
                <BrandIcon src={Icon9} width='100'/>
                <BrandIcon src={Icon10} width='150'/>
                <BrandIcon src={Icon11} width='130'/>
                <BrandIcon src={Icon12} width='160'/>
                <BrandIcon src={Icon13} width='160'/>
                <BrandIcon src={Icon14} width='70'/>
                <BrandIcon src={Icon15} width='70'/>
            </BrandIconsContainer>
            <BrandIconsContainer>
                <BrandIcon src={Icon16} width='140'/>
                <BrandIcon src={Icon17} width='80'/>
                <BrandIcon src={Icon18} width='130'/>
                <BrandIcon src={Icon19} width='140'/>
                <BrandIcon src={Icon20} width='120'/>
                <BrandIcon src={Icon21} width='140'/>
                <BrandIcon src={Icon22} width='100'/>
                <BrandIcon src={Icon23} width='140'/>
      
            </BrandIconsContainer>

            <BrandIconsContainerMobile>
                <BrandIcon src={Icon1}/>
                <BrandIcon src={Icon2}/>
                <BrandIcon src={Icon3}/>
                <BrandIcon src={Icon4}/>
                <BrandIcon src={Icon5}/>
                <BrandIcon src={Icon6}/>
                <BrandIcon src={Icon7}/>
                <BrandIcon src={Icon8}/>
                <BrandIcon src={Icon9}/>
                <BrandIcon src={Icon10}/>
                <BrandIcon src={Icon11}/>
                <BrandIcon src={Icon12}/>
            </BrandIconsContainerMobile>
          </BrandWrapper>
        </BrandContainer>
      </>
    )
}

export default BrandSection
